import * as React from 'react';
import { Checkbox, FormControlLabel, Collapse, TextField } from '@material-ui/core';

import { makeStyles } from '@material-ui/styles'

const useStyle = makeStyles({
    anchor:{
        textDecoration:'none',
        color:'grey',
        '&:hover':{
            color:'darkblue'
        }
    },
    formControl:{
        cursor: 'default'
    }
})

interface CheckboxInterface {
    text:string,
    placeholder?:string,
    changeCheckboxState:Function,
    adress: string
}

export const CheckboxDemand = ({text, placeholder, changeCheckboxState, adress}:CheckboxInterface) => {

    const {anchor, formControl} = useStyle()

    const [collapse, setCollapse] = React.useState(false);
    const changeCollapse = () => {
        changeCheckboxState(!collapse,textField)
        setCollapse(!collapse)
    }

    const [textField, setTextField] = React.useState('')
    const changeTextField = ({target}:any) => {
        setTextField(target.value)
        changeCheckboxState(collapse,target.value)
    }

    React.useEffect(() => {
        changeCheckboxState(collapse,textField)
    }, [collapse, textField])

    return (<>
    <FormControlLabel className={formControl} control={<Checkbox value={collapse} color='primary' onChange={changeCollapse} />} label={<p>{text}: <a className={anchor} target="_blank" href={adress} >{adress}</a> </p>} />
    { placeholder ? <Collapse in={collapse} children={<TextField onChange={changeTextField} placeholder={placeholder} multiline fullWidth />} /> : null }
    </>)
}